import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaMailListViewDnD"*/ "./lazyIndex"), { name: "OwaMailListViewDnD" });
export const lazyCacheMessageToDragAndDrop: LazyAction<typeof lazyIndex.cacheMessageToDragAndDrop, typeof lazyModule> = new LazyAction(lazyModule, m => m.cacheMessageToDragAndDrop);

export const lazyDragToDownloadEmails: LazyAction<typeof lazyIndex.dragToDownloadEmails, typeof lazyModule> = new LazyAction(lazyModule, m => m.dragToDownloadEmails);

export const lazyCacheMessageOnClick: LazyAction<typeof lazyIndex.cacheMessageOnClick, typeof lazyModule> = new LazyAction(lazyModule, m => m.cacheMessageOnClick);
